/**
 * Размеры изображений товара для desktop версии
 */
export const IMAGE_SIZE_DESKTOP = {
	width: 120,
	height: 120
} as const

/**
 * Размеры изображений товара для mobile версии
 */
export const IMAGE_SIZE_MOBILE = {
	width: 75,
	height: 75
} as const
